export default __webpack_public_path__ + "6b8b53d3231e0d676af651d1dd4f7daf.png";